import { render, staticRenderFns } from "./gBackToTop.vue?vue&type=template&id=2be38075&scoped=true&"
import script from "./gBackToTop.vue?vue&type=script&lang=js&"
export * from "./gBackToTop.vue?vue&type=script&lang=js&"
import style0 from "./gBackToTop.vue?vue&type=style&index=0&id=2be38075&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be38075",
  null
  
)

export default component.exports